/**
 * Design tokens v2 — visual SAAS premium pra Multi unidades.
 * Accent monocromatico #5B7CFF, dark glass cardBg rgba, semantic colors
 * (healthy/watch/breach) reservados pra status SLA. Inspirado em
 * Linear, Vercel Dashboard e Stripe.
 */
export const getMUv2Tokens = theme => {
  const isDark = theme?.palette?.type === "dark";
  return {
    isDark,

    // Accent monocromático (UNICA cor primaria do redesign)
    accent: "#5B7CFF",
    accentSoft: "rgba(91,124,255,0.16)",
    accentSoftStrong: "rgba(91,124,255,0.28)",
    accentBorder: "rgba(91,124,255,0.32)",

    // Surfaces (dark glass)
    // O mesmo fundo do invólucro (pages/MultiUnit/index.js).
    pageBg: isDark ? "#0A0A0A" : "#F7F8FA",
    cardBg: isDark ? "rgba(14,16,22,0.85)" : "rgba(255,255,255,0.98)",
    cardBgStrong: isDark ? "rgba(18,20,28,0.96)" : "#ffffff",
    // Modais: as mesmas cores, sólidas (a tela de trás não aparece).
    modalBg: isDark ? "#0E1016" : "#ffffff",
    modalHeaderBg: isDark ? "#12141C" : "#ffffff",
    surfaceBg: isDark ? "rgba(255,255,255,0.03)" : "rgba(248,250,252,0.6)",

    // Borders
    // Cinza neutro; no claro, escuro o bastante para o cartão se destacar do fundo.
    cardBorder: isDark ? "rgba(255,255,255,0.06)" : "rgba(15,23,42,0.16)",
    cardBorderHover: isDark ? "rgba(255,255,255,0.14)" : "rgba(15,23,42,0.28)",

    // Shadows
    cardShadow: isDark
      ? "0 4px 16px rgba(0,0,0,0.24)"
      : "0 4px 16px rgba(15,23,42,0.06)",
    cardShadowHover: isDark
      ? "0 12px 32px rgba(0,0,0,0.42), inset 0 1px 0 rgba(124,154,255,0.08)"
      : "0 12px 32px rgba(15,23,42,0.10)",

    // Text
    textPrimary: isDark ? "#F5F5F5" : "#0F172A",
    textSecondary: isDark ? "#A1A1AA" : "#475569",
    textMuted: isDark ? "#71717A" : "#94A3B8",

    // Semantic (USO PARCIMONIOSO — só status SLA)
    healthy: "#16A34A",
    healthyBg: "rgba(22,163,74,0.12)",
    healthyBorder: "rgba(22,163,74,0.28)",
    healthyText: isDark ? "#4ADE80" : "#15803D",

    watch: "#F59E0B",
    watchBg: "rgba(245,158,11,0.12)",
    watchBorder: "rgba(245,158,11,0.28)",
    watchText: isDark ? "#FBBF24" : "#B45309",

    breach: "#F43F5E",
    breachBg: "rgba(244,63,94,0.12)",
    breachBorder: "rgba(244,63,94,0.28)",
    breachText: isDark ? "#FB7185" : "#BE123C",

    // Glass
    backdropFilter: "blur(12px) saturate(140%)",

    radius: { sm: 6, md: 10, lg: 12, xl: 16 },
    spacing: { xs: 4, sm: 8, md: 12, lg: 16, xl: 24, xxl: 32 }
  };
};

export const slaStatus = (avgSec, thresholds = { ok: 300, warn: 600 }) => {
  if (avgSec == null || avgSec <= 0) return "empty";
  if (avgSec <= thresholds.ok) return "healthy";
  if (avgSec <= thresholds.warn) return "watch";
  return "breach";
};
